import { api, BASE_URL } from "../config";

const ADMIN_OBSERVABILITY_URL = BASE_URL + "admin/observability/";

function cleanParams(params = {}) {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
    );
}

export function listAdminAuditEvents(params = {}) {
    return api
        .get(ADMIN_OBSERVABILITY_URL + "audit-events", { params: cleanParams(params) })
        .then(res => res.data);
}

export function listAdminStripeWebhookEvents(params = {}) {
    return api
        .get(ADMIN_OBSERVABILITY_URL + "stripe-webhook-events", { params: cleanParams(params) })
        .then(res => res.data);
}
